import { reloadForUpdate, useUpdateAvailable } from "@/lib/appUpdate";
import "./updateBanner.css";

// Вышла новая версия, а сама страница перезагрузиться не может — идёт звонок,
// отправка, что-то набрано (lib/appUpdate). Тогда — плашка; сама страница
// перезагрузится, как только станет можно и пользователь уйдёт из вкладки.
export function UpdateBanner() {
  const available = useUpdateAvailable();
  if (!available) return null;
  return (
    <div className="app-update" role="status">
      <span>Вышла новая версия</span>
      <button type="button" onClick={reloadForUpdate}>
        Обновить
      </button>
    </div>
  );
}
